import { environment } from 'src/environments/environment';
import { ReceiptStore } from './model/receipt';

/** Default item when Caltex user submits without adding items. */
export const CALTEX_DEFAULT_RECEIPT_ITEMS = [{ units: 1 }];

export const CALTEX_UAE_EMIRATES = [
  'Abu Dhabi',
  'Dubai',
  'Sharjah',
  'Ajman',
  'Umm Al Quwain',
  'Ras Al Khaimah',
  'Fujairah',
] as const;

/** Match OCR emirate text to a known UAE emirate; returns blank if no match. */
export function matchEmirateFromOcr(
  value: string | undefined | null,
  emirates: readonly string[] = CALTEX_UAE_EMIRATES,
): string {
  if (!value?.trim()) {
    return '';
  }
  const normalized = value.trim();
  return (
    emirates.find(
      (emirate) => emirate.toLowerCase() === normalized.toLowerCase(),
    ) ?? ''
  );
}

/** Parse store list from `/profiles/api/receipt/stores/` response. */
export function normalizeReceiptStores(response: unknown): string[] {
  const items = extractReceiptStoreItems(response);

  return items
    .filter((store) => store.is_active !== false)
    .map((store) => (store.name ?? '').trim())
    .filter(Boolean);
}

function extractReceiptStoreItems(response: unknown): ReceiptStore[] {
  if (Array.isArray(response)) {
    return response as ReceiptStore[];
  }

  const data = response as {
    results?: ReceiptStore[];
    result?: ReceiptStore[];
  };

  return data.results ?? data.result ?? [];
}

export function isCaltexApp(): boolean {
  return environment.settings.app === 'caltex';
}
